var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-3" },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "capitalize",
                attrs: {
                  name: "nome",
                  label: "nome",
                  error: _vm.errors.has("nome"),
                  "error-messages": _vm.errors.first("nome")
                },
                model: {
                  value: _vm.account.first_name,
                  callback: function($$v) {
                    _vm.$set(_vm.account, "first_name", $$v)
                  },
                  expression: "account.first_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  name: "sobrenome",
                  label: "sobrenome",
                  error: _vm.errors.has("sobrenome"),
                  "error-messages": _vm.errors.first("sobrenome")
                },
                model: {
                  value: _vm.account.last_name,
                  callback: function($$v) {
                    _vm.$set(_vm.account, "last_name", $$v)
                  },
                  expression: "account.last_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  name: "email",
                  label: "email",
                  disabled: "",
                  error: _vm.errors.has("email"),
                  "error-messages": _vm.errors.first("email")
                },
                model: {
                  value: _vm.account.email,
                  callback: function($$v) {
                    _vm.$set(_vm.account, "email", $$v)
                  },
                  expression: "account.email"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  name: "ocupação",
                  label: "ocupação",
                  error: _vm.errors.has("ocupação"),
                  "error-messages": _vm.errors.first("ocupação")
                },
                model: {
                  value: _vm.account.occupation,
                  callback: function($$v) {
                    _vm.$set(_vm.account, "occupation", $$v)
                  },
                  expression: "account.occupation"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-select", {
                attrs: {
                  disabled: "",
                  value: _vm.account.language,
                  items: _vm.locales(),
                  label: "linguagem"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { "px-1": "", lg4: "", md6: "", xs12: "" } },
            [
              _c("v-select", {
                attrs: {
                  disabled: "",
                  value: _vm.account.time_zone,
                  items: _vm.timeZones(),
                  label: "timezone"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("phones", { attrs: { account: _vm.account } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.status
        ? _c(
            "v-layout",
            { attrs: { row: "", "justify-end": "", "align-end": "" } },
            [
              _vm.status.order === 4
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "deactivate",
                        disabled: _vm.loader != false,
                        color: "warning",
                        rounded: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitChangeStatus(
                            "deactivate",
                            "desativada"
                          )
                        }
                      }
                    },
                    [
                      _vm._v("\n      inativar\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("remove_circle_outline")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status.order === 5
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "activate",
                        disabled: _vm.loader != false,
                        color: "success",
                        rounded: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitChangeStatus("activate", "ativada")
                        }
                      }
                    },
                    [
                      _vm._v("\n      ativar\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("done_all")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status.order === 5
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "block",
                        disabled: _vm.loader != false,
                        color: "error",
                        rounded: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitChangeStatus("block", "bloqueada")
                        }
                      }
                    },
                    [
                      _vm._v("\n      bloquear\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("block")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status.order === 6
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "unblock",
                        disabled: _vm.loader != false,
                        color: "warning",
                        rounded: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitChangeStatus(
                            "unblock",
                            "desbloqueada"
                          )
                        }
                      }
                    },
                    [
                      _vm._v("\n      desbloquear\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("remove_circle_outline")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status.order === 2
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "verifyEmail",
                        disabled: _vm.loader != false,
                        color: "success",
                        rounded: ""
                      },
                      on: { click: _vm.submitVerifyEmail }
                    },
                    [
                      _vm._v("\n      verificar email\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("check")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status.order < 3
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loader === "sendEmailVerification",
                        disabled: _vm.loader != false,
                        color: "warning",
                        rounded: ""
                      },
                      on: { click: _vm.submitEmailVerification }
                    },
                    [
                      _vm._v("\n      enviar email de verificação\n      "),
                      _c(
                        "v-icon",
                        { staticClass: "ml-10", attrs: { small: "" } },
                        [_vm._v("email")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.loader === "update",
                    disabled: _vm.loader != false,
                    color: "primary",
                    rounded: ""
                  },
                  on: { click: _vm.submit }
                },
                [
                  _vm._v("\n      enviar\n      "),
                  _c("v-icon", { staticClass: "ml-10", attrs: { small: "" } }, [
                    _vm._v("send")
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d42fea4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d42fea4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Users/Account/Attributes.vue
// module id = null
// module chunks = 